import { some } from 'lodash';

function anyCheckedValidation(checkBoxFields) {
  return (value, message) => (
    !value && some(checkBoxFields, { value: true }) ? message : null
  );
}

export default anyCheckedValidation;
